import React, {useState} from 'react';
import Breadcrumbs from './Breadcrumbs';


const Contact = () => {
  const [userData, setUserData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  let name, value;
  const postUserData = (event) => {
    name = event.target.name;
    value = event.target.value;

    setUserData({ ...userData, [name]: value });
  };

  // connect with firebase
  const submitData = async (event) => {
    event.preventDefault();
    const { name,  phone, email, message } = userData;

    if (name && phone && email && message) {
      const res = fetch(
        "https://covidenq-eb54c-default-rtdb.firebaseio.com/contactRecords.json",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            phone,
            email,
            message,
          }),
        }
      );

      if (res) {
        setUserData({
          name: "",
          phone: "",
          email: "",
          message: "",
        });
        alert("Data Stored");
      } else {
        alert("plz fill the data");
      }
    } else {
      alert("plz fill the data");
    }
  };
    return (
        <>
        <Breadcrumbs name="Contact Us" linename="contact"/>
            <section id="contact" class="contact">
      <div class="container">

       
        <div class="row mt-5">

          

          <div class="col-lg-12 mt-5 mt-lg-0">

            <form action="forms/contact.php" method="post" role="form" class="php-email-form">
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <input type="text" name="name"  value={userData.name}
                          onChange={postUserData} class="form-control" id="name" placeholder="Your Name" data-rule="minlen:4" data-msg="Please enter at least 4 chars" />
                  <div class="validate"></div>
                </div>
                <div class="col-md-6 form-group">
                  <input type="email" class="form-control" name="email"
                   value={userData.email}
                          onChange={postUserData}
                   id="email" placeholder="Your Email" data-rule="email" data-msg="Please enter a valid email" />
                  <div class="validate"></div>
                </div>
              </div>
              <div class="form-group">
                <input type="text" class="form-control"
                 name="phone"
                 value={userData.phone}
                          onChange={postUserData}
                           id="subject" placeholder="Phone Number" data-rule="minlen:4" data-msg="Please enter at least 8 chars of subject" />
                <div class="validate"></div>
              </div>
              <div class="form-group">
                <textarea class="form-control" name="message"
                 value={userData.message}
                          onChange={postUserData}
                           rows="5" data-rule="required" data-msg="Please write something for us"
                 placeholder="Message"></textarea>
               
              </div>
             
              <div class="text-center"><button type="submit" onClick={submitData}>Send Message</button></div>
            </form>

          </div>

        </div>

      </div>
    </section>
            
        </>
    )
}

export default Contact;
